import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_ALL_FILES = restRequest("FILE_UPLOAD_WIDGET.GET_ALL_FILES");
export const UPLOAD_FILE = restRequest("FILE_UPLOAD_WIDGET.UPLOAD_FILE");
export const GET_FOLDERS = restRequest("FILE_UPLOAD_WIDGET.GET_FOLDERS");
export const SET_FOLDER = "FILE_UPLOAD_WIDGET.SET_FOLDER";
